"use client"
import useOneTrustOptInLoad from "@/app/(site)/_utils/_hooks/useOneTrustOptInLoad"
import Script from "next/script"

export const KlaviyoScript = () => {
    // check if the user has given consent to the functional cookies
    const consent = useOneTrustOptInLoad()
    return consent?.targetingConsent || consent?.socialMediaConsent ? (
        <Script
            strategy="afterInteractive"
            src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.NEXT_PUBLIC_KLAVIYO_ID}`}
            id={`klaviyo-script-${process.env.NEXT_PUBLIC_KLAVIYO_ID}`}
        />
    ) : null
}
